import { AccordionView } from "common/views/accordion/Accordion.view";
import { CarouselView } from "common/views/carousel/Carousel.view";
import { RowsView } from "common/views/rows/Rows.view";
import DataTable from "common/views/table/DataTable";
import { Fragment, IDataFragment } from "core/components/FragmentProvider";
import Course from "panels/catalog/entities/Course";
import { ICourseParams } from "panels/catalog/entities/CourseParams";
import * as catalogActions from "../../catalogActions";

export interface IParentContainerFragmentProps {
	children?: JSX.Element[];
	courses?: Course[];
	params?: ICourseParams;
	renderItem?: (course: Course, index?: number) => JSX.Element;
	renderExpand?: (course: Course) => JSX.Element;
	courseFragments?: Array<IDataFragment<any>>;
	actions?: typeof catalogActions;
}

function getKey(course: Course) { return course.id; }

export const rows: Fragment<IParentContainerFragmentProps> = {
	name: "Rows",
	component: ({courses, renderItem}) => (
		<RowsView
			items={courses}
			renderItem={renderItem}
			viewKey="cartList.container.rows"
		/>
	)
};



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/fragments/cartParentContainerFragments.tsx